import {
  OyResponse,
  UserManagement,
  UserManagementDeleteUserRequest,
  UserManagementRequest,
} from '@oy/types';
import axios, { AUTH_PREFIX, AUTH_PREFIX_V2 } from 'src/clients/axios';

export const GET_USER_LIST_URL = `${AUTH_PREFIX}/account/users/list`;

export function getUserList(companyId: string) {
  return axios.get<OyResponse<UserManagement[]>>(GET_USER_LIST_URL, {
    params: { company_id: companyId },
  });
}

export const updateSubProfile = (data: UserManagementRequest) => {
  return axios.put(`${AUTH_PREFIX_V2}/account/users`, data);
};

export function deleteUser(data: UserManagementDeleteUserRequest) {
  return axios.delete(`${AUTH_PREFIX}/account/users`, { data });
}

export const createSubProfile = (data: UserManagementRequest) => {
  return axios.post(`${AUTH_PREFIX}/account/users`, data);
};
